import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { events } from '../events.js';
import { SideSheetContext } from './context.js';

const SideSheetProvider = ({ children })=>{
    const [history, setHistory] = useState([]);
    const current = useMemo(()=>{
        return history.at(-1);
    }, [
        history
    ]);
    /**
     * Wrapper function to emit side sheet events during the routing.
     */ const emitEvent = useCallback((eventName, context, callback)=>{
        void events.emit(eventName, {
            current,
            ...context
        }).finally(callback);
    }, [
        current
    ]);
    const push = useCallback((entry, event)=>{
        emitEvent('onPush', {
            event
        }, ()=>setHistory((prev)=>{
                return [
                    ...prev,
                    entry
                ];
            }));
    }, [
        emitEvent
    ]);
    const clear = useCallback((event)=>{
        emitEvent('onClear', {
            event
        }, ()=>{
            setHistory([]);
        });
    }, [
        emitEvent
    ]);
    const back = useCallback((event)=>{
        emitEvent('onBack', {
            event
        }, ()=>setHistory((prev)=>{
                if (prev.length <= 1) {
                    return [];
                }
                return prev.slice(0, -1);
            }));
    }, [
        emitEvent
    ]);
    useEffect(()=>{
        // Subscribe to the "onPageChange" event and clear the side sheet history when it occurs
        const unsubscribe = events.on('onPageChange', ()=>{
            clear();
        });
        // Unsubscribe on unmount
        return ()=>{
            unsubscribe();
        };
    }, [
        clear
    ]);
    return jsx(SideSheetContext.Provider, {
        value: {
            router: {
                push,
                clear,
                back
            },
            current,
            history,
            events
        },
        children: children
    });
};

export { SideSheetProvider };
//# sourceMappingURL=provider.js.map
